<template>
    <div class="form-add-client" :class="{'form-add-client__easter-container': easterEgg}">
        <div class="form-add-client__title">
            {{!easterEgg ? title : 'Пасхалочка'}}
        </div>
        <div v-if="!easterEgg" class="form-add-client__input">
            <input
                :placeholder="placeholder"
                v-model="name"
            />
        </div>
        <div class="form-add-client__easter" v-if="easterEgg">
            <img-container
                    :lazySrc="imageSrc"
                    :lazySrcset="imageSrc"
                    :width="300"
                    :height="52"
            />
            <audio autoplay>
                <source v-bind:src="audioSrc" type="audio/mpeg">
            </audio>
        </div>
        <div class="form-add-client__btn-container">
            <button class="form-add-client__button" @click="onClickCancel">Отмена</button>
            <button
                class="form-add-client__button form-add-client__action-button"
                v-if="name !== ''"
                type="submit"
                @click="onClickSubmit"
            >
                Сохранить
            </button>
        </div>
    </div>
</template>

<script>
import ImgContainer from "../Base/ImgContainer";

export default {
    name: 'FormAddClient',
    components: {
        ImgContainer
    },
    /**
     * Данные компонента
     * @property {boolean} easterEgg - пасхалка для Влада
     */
    data: () => ({
        easterEgg: false,
        imageSrc: '',
        audioSrc: ''
    }),
    /**
     * входные данные компонента
     * @property {string} name - название клиента
     */
    props: {
        name: {
            type: String,
            default: ''
        },
        placeholder: {
          type: String,
          default: 'Введите название нового клиента'
      },
      title: {
        type: String,
        default: 'Создание клиента'
      },
    },
    methods: {
        /**
         * событие отправки имени новой группы
         */
        onClickSubmit() {
            let loverCase = this.name.toLowerCase();
            console.log(loverCase);
            if(
                loverCase === 'стрелкин'
                || loverCase === 'казаков'
            ){
                this.easterEgg = true;
                this.name = '';
                this.imageSrc = loverCase === 'стрелкин'
                    ? require("../../assets/images/strelkin.jpg")
                    : require("../../assets/images/kazakov.jpg");
                this.audioSrc = loverCase === 'стрелкин'
                    ? 'https://www.dropbox.com/s/7w0ommxb680wu18/zvuk-ou-e-gde-kto-to-voshischaetsya-chem-to-seksualnyim-muzyika-iz-kakogo-to-starogo-filma-3410.mp3?raw=1'
                    : 'https://www.dropbox.com/s/8g8ewm2wc292v2u/muzyika-s-proydennoy-missiey-iz-gta-san-andreas-mission-complete-3395.mp3?raw=1';
            }else {
                this.$emit('submitForm', this.name);
            }

        },
        onClickCancel(){
            this.$emit('cancelForm');
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-add-client {
        height: 150px;
        width: 400px;
    }
    .form-add-client__title {
        text-align: center;
        font-size: 20px;
        margin: 20px 20px 20px 20px;
    }
    .form-add-client__input {
        text-align: center;
        margin: 20px 20px 20px 20px;
    }
    .form-add-client__input input {
        width: 100%;
    }
    .form-add-client__btn-container {
        text-align: end;
        margin: 20px 20px 20px 20px;
    }
    .form-add-client__button{
        cursor: pointer;
        pointer-events: auto;
        height: 32px;
        width: min-content;
        padding: 4px 14px;
        border-radius: 100px;
        transition: 0.3s;
        border: 1px solid transparent;
        outline: none;
    }
    .form-add-client__action-button{
        margin-left: 5px;
        color: #000;
        background: #fe1060;
    }
    .form-add-client__easter{
        text-align: center;
    }
    .form-add-client__easter-container{
        height: 520px;
    }
</style>